const state = {
    abbriviation: null,
    app_name: null,
    app_store: null,
    play_store: null,
};


const getters = {
    getAbbriviation: (state) => {
        return state.abbriviation;
    },
    getAppName: (state) => {
        return state.app_name;
    },
    getAppStore: (state) => {
        return state.app_store;
    },
    getPlayStore: (state) => {
        return state.play_store;
    },
};

const mutations = {
    pushAgencyConfig: (state, agencyConfig) => {
        state.abbriviation = agencyConfig.abbriviation;
        state.app_name = agencyConfig.app_name;
        state.app_store = agencyConfig.app_store;
        state.play_store = agencyConfig.play_store;
    }
};

const actions = {
};



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}